import useTakerMarketsGroups from '@/enterprise/data/useTakerMarketsGroups';
import { OfferModalWithContext } from '@/enterprise/features/offerModal/OfferModalContext';
import QueryBoundaries from '@/shared/components/QueryBoundaries';
import MarketTable from './MarketTable';

const FixedRateMarketTableComponent = () => {
  const {
    FIXED: { takerMarkets },
  } = useTakerMarketsGroups();

  return <MarketTable takerMarkets={takerMarkets} />;
};

const FixedRateMarketTable = () => {
  return (
    <QueryBoundaries>
      <OfferModalWithContext>
        <FixedRateMarketTableComponent />
      </OfferModalWithContext>
    </QueryBoundaries>
  );
};

export default FixedRateMarketTable;
